import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import { userActionPersistor } from './middlewares';
import { rootReducer } from './reducers';

const middlewares = [thunk, userActionPersistor];

export const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(...middlewares)));
